var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaleader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.704,
    height: 138.132,
    viewBox: "0 0 108.704 138.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5",
    "data-name": "Rettangolo 5",
    width: 108.704,
    height: 138.132,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M108.7,95.041a8.41,8.41,0,0,0-8.258-8.258H84.981V0H36.335V10.51H0L13.213,32.731,0,54.953H59.607V45.343H78.976v31.23H60.958A15.309,15.309,0,0,0,50.3,80.928H15.765v57.2H51.8v-5.555a15.319,15.319,0,0,0,9.309,3.153H94.891c3.754,0,7.207-3.9,7.207-8.258a8.243,8.243,0,0,0-1.051-4.054,8.858,8.858,0,0,0,3.153-6.756,8.274,8.274,0,0,0-1.2-4.2,8.257,8.257,0,0,0,2.4-10.81,8.259,8.259,0,0,0,3.3-6.606M42.341,6.006H78.976V39.338H42.341ZM53.6,48.947H10.66L20.42,32.731,10.66,16.516H36.335V45.343H53.6Zm-7.807,83.18H21.921V86.933H45.794Zm49.1-2.252H61.109a9.308,9.308,0,0,1-9.309-9.309V92.038a9.309,9.309,0,0,1,9.157-9.458H79.126v4.2H68.616a3,3,0,1,0,0,6.006H100.3a2.327,2.327,0,1,1,0,4.654h-3a3.007,3.007,0,1,0-.3,6.006h1.051a2.327,2.327,0,0,1,0,4.654h-3a3.007,3.007,0,0,0-.3,6.006h1.051a2.252,2.252,0,0,1,2.252,2.252,2.854,2.854,0,0,1-1.2,2.252h-3.9a3.007,3.007,0,1,0-.3,6.006H93.69a2.253,2.253,0,0,1,2.252,2.252,2.852,2.852,0,0,1-1.051,3",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M24.754,77.9A4.053,4.053,0,1,1,20.7,81.952,4.053,4.053,0,0,1,24.754,77.9",
    transform: "translate(10.38 39.062)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaleader);
export default __webpack_public_path__ + "static/media/iconaleader.b959a3c8e522499a5481e2bedd978465.svg";
export { ForwardRef as ReactComponent };